const Welcome = () => import('~/pages/welcome')
const Login = () => import('~/pages/auth/login')
const Register = () => import('~/pages/auth/register')
const PasswordEmail = () => import('~/pages/auth/password/email')
const PasswordReset = () => import('~/pages/auth/password/reset')
const Requerimentos = () => import('~/pages/secretaria/requerimentos')
const Inscricoes = () => import('~/pages/secretaria/inscricoes')

const Home = () => import('~/pages/home')
const Settings = () => import('~/pages/settings/index')
const SettingsProfile = () => import('~/pages/settings/profile')
const SettingsPassword = () => import('~/pages/settings/password')

export default [
  { path: '/', name: 'welcome', component: Welcome },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },
  { path: '/secretaria/requerimentos', name: 'requirements', component: Requerimentos },
  { path: '/secretaria/inscricoes', name: 'subscriptions', component: Inscricoes },
  { path: '/secretaria/inscricoes/:curso-:id', name: 'subscriptions', component: Inscricoes, props: true },

  { path: '/home', name: 'home', component: Home },
  { path: '/settings', component: Settings, children: [
    { path: '', redirect: { name: 'settings.profile' }},
    { path: 'profile', name: 'settings.profile', component: SettingsProfile },
    { path: 'password', name: 'settings.password', component: SettingsPassword }
  ] },

  { path: '*', component: require('~/pages/errors/404') }
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js